import * as go from 'gojs';
import { highlightAncestors, highlightPredecessors } from '../../../utils/highlight-utils';

export const mouseHover = (e: go.InputEvent, link: go.GraphObject): void => {
  (link as go.Link).isHighlighted = true;
  const node =
    e.diagram.findNodeForKey((link as go.Link).data.to) || e.diagram.findNodeForKey((link as go.Link).data.from);

  if (!node) {
    return;
  }

  highlightPredecessors(node);
  highlightAncestors(node);
};

export const mouseLeave = (e: go.InputEvent): void => {
  e.diagram.clearHighlighteds();
};
